import React, { useEffect, useState, useCallback } from 'react';
import { ColumnsType } from 'antd/es/table';
import { useTranslation } from 'react-i18next';
import { useTypedSelector } from '../../../../hooks/useTypedSelector';
import { useActions } from '../../../../hooks/useActions';
import * as S from './GradingTable.styles';
import { IGradingsState } from '../../../../store/reducers/grading/types';

interface DataType {
  key: number;
  examName: string;
  status: string;
  approve: string;
  date: string;
}

interface Props {
  gradings: [],
}

const columns: ColumnsType<DataType> = [
  {
    title: 'Exam',
    dataIndex: 'examName',
    render: (text: string) => <a defaultValue={text}>{text}</a>,
  },
  {
    title: 'Date',
    dataIndex: 'date',
  },
  {
    title: 'Status',
    dataIndex: 'status',
  },
  {
    title: 'Approve',
    dataIndex: 'approve',
  }
];

export const GradingTable = (props: Props) => {
  const { t } = useTranslation();
  const { selectedGrading } = useTypedSelector<IGradingsState>(state => state.gradings)
  const { getGradingRequest } = useActions();
  const [selectedGradingitem, setSelectedGradingitem] = useState<number>(-1);
  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: DataType[]) => {
      setSelectedGradingitem(parseInt(selectedRowKeys.toString()));
    },
  };

  useEffect(() => {
    if (selectedGradingitem != -1) {
      getGradingRequest();
    }
  }, [selectedGradingitem]);

  return (
    <S.Card id="basic-table" title={t('grading:title')} padding="1.25rem 1.25rem 0">
      <S.Table
        rowClassName={(record, index) => selectedGradingitem != index ? '' : 'ant-table-row-selected'}
        rowSelection={{
          type: 'radio',
          ...rowSelection,
        }}
        columns={columns}
        dataSource={props.gradings.map((el: any, key: any) => {
          return ({
            key: key,
            examName: el.examName,
            examFormName: el.examFormName,
            className: el.className,
            gradingScaleName: el.gradingScaleName,
            date: el.dateOfCreate
          })
        })}
        onRow={(record) => ({
          onClick: () => {
            rowSelection.onChange([record.key], props.gradings[record.key]);
          }
        })}
      />
    </S.Card>

  );
};
